import { Grid } from '@mantine/core';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const TextMessagesStats = ({ stats, textMessage, period, currency }) => {
  const { accountId, domainId } = useParams();

  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${textMessage.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  if (!stats) {
    return (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  }

  return (
    <>
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Sent"
              stats={stats}
              stat="sent"
              id={textMessage.id}
              statKey="count"
              link={segmentLink('textMessageSend')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Delivered"
              stats={stats}
              stat="deliveries"
              percentageOfStat="sent"
              id={textMessage.id}
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Clicks"
              stats={stats}
              stat="clicks"
              percentageOfStat="deliveries"
              id={textMessage.id}
              statKey="count"
              link={segmentLink('textMessageClicks')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Conversions"
              stats={stats}
              stat="conversions"
              percentageOfStat="clicks"
              id={textMessage.id}
              statKey="count"
              link={segmentLink('textMessageConversion')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Purchases"
              stats={stats}
              stat="purchases"
              percentageOfStat="conversions"
              id={textMessage.id}
              statKey="count"
              link={segmentLink('textMessagePurchase')}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Revenue"
              stats={stats}
              stat="purchases"
              id={textMessage.id}
              statKey="value"
              currency={currency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic
              title="Unsubscribes"
              stats={stats}
              stat="unsubscribes"
              id={textMessage.id}
              percentageOfStat="sent"
              statKey="count"
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Bounces"
              stats={stats}
              stat="bounces"
              id={textMessage.id}
              statKey="count"
              link={segmentLink('viberMessageBounce')}
            />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </>
  );
};
export default TextMessagesStats;
